import {
  Button,
  Card,
  CardContent,
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "alm-react-components";
import MyNoteIcon from "../../../../assets/images/svgicons/my-note-icon.svg";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { constants } from "../../../../assets/constants/constants";
const NotesTab = ({ notesData }: { notesData: any }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <>
      <Carousel className="mt-12">
        <div className="flex flex-wrap justify-end">
          {notesData?.length ? (
            <Button
              variant="outline"
              onClick={() => navigate(`/notes`)}
              className="w-max h-auto text-base border-0 font-opensansMedium rounded px-8 bg-fillMidGrayCard py-1 md:min-h-10"
            >
              {t("Common.seeAll")}
            </Button>
          ) : null}
        </div>
        {notesData?.length > 0 ? (
          <>
            <CarouselContent className="mt-6 flex -ml-4 lg:flex-row lg:gap-0 md:gap-0 md:flex md:flex-row">
              {notesData?.map((res: any) => {
                return (
                  <>
                    <CarouselItem className="landscape:2xl:basis-1/4 landscape:xl:basis-1/4 landscape:lg:basis-1/3 landscape:md:basis-1/2 portrait:md:basis-1/2 landscape:sm:basis-1/2 portrait:sm:basis-1/2 md:pl-5">
                      <Card className="dark:bg-fillMidGrayCard h-full dark:text-white rounded-2xl border-0 pt-9 pb-6 flex flex-col flex-1">
                        <div className="mx-auto w-full flex justify-center">
                          <img
                            src={MyNoteIcon}
                            className=""
                            alt="My Note Icon Image"
                          />
                        </div>
                        <CardContent className="py-0">
                          <p className="text-2xl font-barlowLight text-white leading-tight text-center pt-5 min-h-[78px]">
                            {res?.programName
                              ? res?.programName
                              : res?.courseName}
                          </p>
                        </CardContent>
                        <div className="mt-auto p-6 pb-2 flex">
                          <Button
                            onClick={() =>
                              navigate(
                                `/program-notes?almCommentId=${
                                  res?.programId
                                    ? res?.programId
                                    : res?.almCommentId
                                }`
                              )
                            }
                            variant="secondary"
                            className="text-base font-medium px-6 py-1 h-9 border w-full dark:bg-primary text-primary-foreground "
                            dangerouslySetInnerHTML={{
                              __html: t("MyStance.viewNotes"),
                            }}
                          ></Button>
                        </div>
                      </Card>
                    </CarouselItem>
                  </>
                );
              })}
              {notesData?.length > constants.SEE_MORE_LIMITS && (
                <CarouselItem className="landscape:2xl:basis-1/4 landscape:xl:basis-1/4 landscape:lg:basis-1/3 landscape:md:basis-1/2 portrait:md:basis-1/2 landscape:sm:basis-1/2 portrait:sm:basis-1/2 md:pl-5">
                  <Card
                    onClick={() => navigate("/notes")}
                    className="w-full h-full p-0 bg-fillMidGrayCard cursor-pointer border-cardBorder relative flex items-center justify-center"
                  >
                    <CardContent className="mt-4 px-5">
                      <div
                        className="text-2xl"
                        dangerouslySetInnerHTML={{
                          __html: t("Common.seeMore"),
                        }}
                      />
                    </CardContent>
                  </Card>
                </CarouselItem>
              )}
            </CarouselContent>
            <div className="carousel-prev-next-box">
              <CarouselPrevious className="carousel-prev-btn top-full mt-5 translate-y-0" />
              <CarouselNext className="carousel-next-btn right-0 top-full bottom-0 mt-5 translate-y-0" />
            </div>
          </>
        ) : (
          <div
            className="flex w-full justify-center text-2xl"
            dangerouslySetInnerHTML={{ __html: t("MyStance.noNotesFound") }}
          />
        )}
      </Carousel>
    </>
  );
};

export default NotesTab;
